import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ReactComponent as OrbsIcon } from '@pkg/components/Sections/Profile/icons/orbs.svg';

export const PreviewWrapper = styled(motion.div)`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Blur = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.purple};
    opacity: 0.2;
    filter: blur(50px);
`;

export const Orbs = styled(OrbsIcon)`
    &&& {
        position: absolute;
        width: 150%;
        height: 150%;
        max-width: none;
    }
`;
